function callPhone(data) {
  if (!data || JSON.stringify(data) == '[]' || JSON.stringify(data) == '{}') return;
  const phone = data.phone;
  const a = document.createElement('a');
  a.setAttribute('href', `tel:${phone}`);
  document.body.appendChild(a);
  a.click();
  a.remove();
}

export default {
  callPhone,
};
